import { useState, useEffect } from 'react';
import { useSiteInfo } from '@contexts/SiteInfoContext';
import useVideoData from './useVideoData';

const Video = () => {
    const {
        siteName, allowedIp, supportedLanguages,
        imageDomain = 'http://glombi.accordde.com/video',
        versionNumber = '1.0',
    } = useSiteInfo();
    const [videoList, setVideoList] = useState({
        primaryVideo: [], secondaryVideo: [], otherVideo: [],
    });

    const { videoData, isLoading } = useVideoData(
        supportedLanguages,
        versionNumber,
    );

    useEffect(() => {
        if (videoData) {
            setVideoList({
                primaryVideo: [videoData[0]],
                secondaryVideo: [videoData[1], videoData[2]],
                otherVideo: videoData.slice(2),
            });
        }
    }, [videoData]);

    return [];

    return (
        !isLoading && (
            <div className="sport-highlights" data-open="true">
                <div className="sport-highlights__promo">
                    {
                        videoList?.primaryVideo.map(({ date, poster, title }, index) => {
                            return (
                                <div className="video video--promo" data-selected="false">
                                    <div className="video__main">
                                        <div className="video__play">
                                            <a className="btn" data-selected="false">
                                                <i className="icon icon--play" />
                                                <i className="icon icon--pause" />
                                            </a>
                                        </div>
                                        <div className="video__source">
                                            <img
                                                // src={`${imageDomain}/${poster}?v=${versionNumber}`}
                                                src="https://images.theconversation.com/files/443350/original/file-20220131-15-1ndq1m6.jpg?ixlib=rb-1.1.0&rect=0%2C0%2C3354%2C2464&q=45&auto=format&w=926&fit=clip"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                    <div className="video__info">
                                        <span className="text">{`${index + 1} ${title.cs} ${date}`}</span>
                                    </div>
                                </div>
                            );
                        })
                    }
                    {
                        videoList?.secondaryVideo.map(({ date, poster, title }, index) => {
                            return (
                                <div className="video" data-selected="false">
                                    <div className="video__main">
                                        <div className="video__play">
                                            <span className="text">Playing</span>
                                        </div>
                                        <div className="video__source">
                                            <img src={`${imageDomain}/${poster}?v=${versionNumber}`} alt="" />
                                        </div>
                                    </div>
                                    <div className="video__info">
                                        <span className="text">{`${index + 2} ${title.cs} ${date}`}</span>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
                <div className="sport-highlights__list">
                    {
                        videoList?.otherVideo.map(({ date, poster, title }, index) => {
                            return (
                                <div className="video" data-selected="false">
                                    <div className="video__main">
                                        <div className="video__play">
                                            <span className="text">Playing</span>
                                        </div>
                                        <div className="video__source">
                                            <img src={`${imageDomain}/${poster}?v=${versionNumber}`} alt="" />
                                        </div>
                                    </div>
                                    <div className="video__info">
                                        <span className="text">{`${index + 3} ${title.cs} ${date}`}</span>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        )
    );
};

export default Video;
